module.exports = __webpack_public_path__ + "assets/c1bd9850d4757d96d96ddf2fefd54651.mp3";